import { Button } from "alm-react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import checkLineIcon from "./../../../assets/images/svgicons/check-line-icon.svg";
import { PropBasedAlertBox } from "../../common/PropBasedAlertBox";
  
export const ProgramFinishButton = ({
  isProgramCompleted,
  finishedProgram,
  callProgramCompleteApi,
}: any) => {
  const { t } = useTranslation();
  const [visible,setVisible]=useState<boolean>(false);

  const alreadyCompletedMsg = () => {
    setVisible(true)
  };
  return (
    <>
    {  visible && <PropBasedAlertBox
    message={t("Common.alreadyCompletedText")}
    setVisible={    setVisible      }
    />
    }
      {isProgramCompleted ? (
        <Button
          variant={"secondary"}
          className="sm:px-12 md:px-24 font-opensansMedium text-base"
          onClick={() => alreadyCompletedMsg()}
        >
          <span dangerouslySetInnerHTML={{ __html: t("Common.programCompleted") }} />
          <img
          src={checkLineIcon} //name of svg file
          className= "logo ms-3 text-sm"
          />
        </Button>
      ) : (
        <Button
          variant={finishedProgram ? "default" : "secondary"}
          className={`sm:px-12 md:px-24 font-opensansMedium text-base   ${ finishedProgram ? '':'bg-[#cccccc] disabled:opacity-[1] dark:text-[#666666]'}`}
          onClick={() => callProgramCompleteApi()}
        >
          <span dangerouslySetInnerHTML={{ __html: t("Common.finishProgram") }} />
        </Button>
      )}
    </>
  );
};
 
